<template>
    <div class="chat-leftsidebar">
        <div class="d-lg-none d-flex justify-content-between align-items-center px-4 pt-3">
            
            <div class="d-flex align-items-center gap-3">
                <DropdownField :distance="14" placement="bottom-start" class="cursor-pointer" :auto-hide="true">
                    <div class="position-relative">
                        <i class="ri-notification-line font-size-22 text-secondary"></i>
                        <span v-if="notificationStore.unreadCount > 0" class="position-absolute top-0 start-100 translate-middle badge rounded-pill bg-danger shadow-sm" style="font-size: 0.60rem; padding: 0.2rem 0.35rem;">
                            {{ notificationStore.unreadCount }}
                        </span>
                    </div>
                    <template #popper>
                        <div class="notification-dropdown">
                            
                            <div class="dropdown-header-custom d-flex justify-content-between align-items-center z-2 sticky-top">
                                <h6 class="m-0 fw-bold font-size-16">Notificações</h6>
                                <button 
                                    v-if="notificationStore.unreadCount > 0"
                                    @click="notificationStore.markAllAsRead()"
                                    class="btn btn-link text-primary p-0 text-decoration-none font-size-12 fw-semibold btn-mark-read"
                                >
                                    Marcar como lidas
                                </button>
                            </div>

                            <div class="notification-body custom-scrollbar">
                                <div v-if="notificationStore.isLoading" class="p-5 text-center text-muted d-flex flex-column align-items-center gap-2">
                                    <i class="ri-loader-4-line ri-spin font-size-24 text-primary"></i> 
                                    <span class="font-size-13">Buscando atualizações...</span>
                                </div>
                                
                                <div v-else-if="notificationStore.notifications.length === 0" class="p-5 text-center text-muted d-flex flex-column align-items-center gap-3 empty-state">
                                    <div class="icon-empty-state rounded-circle d-flex align-items-center justify-content-center" style="width: 64px; height: 64px;">
                                        <i class="ri-notification-off-line font-size-24 text-muted"></i>
                                    </div>
                                    <span class="font-size-14 fw-medium">Tudo tranquilo por aqui!</span>
                                </div>

                                <div v-else
                                    v-for="notif in notificationStore.notificationsWithTimeAgo"
                                    :key="notif.id"
                                    class="notification-item cursor-pointer d-flex gap-3 position-relative"
                                    :class="!notif.lida ? 'is-unread' : ''"
                                    @click="notificationStore.markAsRead(notif.id); notificationStore.handleClickNotificacao(notif)"
                                >
                                    <div v-if="!notif.lida" class="unread-indicator"></div>

                                    <div class="flex-shrink-0 mt-1">
                                        <div class="notif-icon-wrapper rounded-circle d-flex align-items-center justify-content-center" :class="`icon-${notif.tipo}`">
                                            <i v-if="notif.tipo === 'ATENDIMENTO_TRANSFERIDO'" class="ri-share-forward-line"></i>
                                            <i v-else-if="notif.tipo === 'ATENDIMENTO_FINALIZADO'" class="ri-checkbox-circle-line"></i>
                                            <i v-else-if="notif.tipo === 'SINCRONIZACAO_CONTATOS_CONCLUIDA'" class="ri-refresh-line"></i>
                                            <i v-else-if="notif.tipo === 'IMPORTACAO_CONTATOS_CONCLUIDA'" class="ri-contacts-book-upload-line"></i>
                                            <i v-else-if="notif.tipo === 'EXPORTACAO_CONVERSAS_CONCLUIDA'" class="ri-download-cloud-2-line"></i>
                                            <i v-else-if="notif.tipo === 'EXPORTACAO_CONVERSAS_ERRO'" class="ri-error-warning-line"></i>
                                            <i v-else class="ri-notification-3-line"></i>
                                        </div>
                                    </div>
                                    
                                    <div class="flex-grow-1 overflow-hidden">
                                        <div class="d-flex justify-content-between align-items-start mb-1 gap-2">
                                            <h6 class="m-0 font-size-14 text-truncate notif-title" :class="!notif.lida ? 'fw-bold' : 'fw-semibold'">
                                                {{ notif.titulo }}
                                            </h6>
                                            <span class="font-size-11 text-muted flex-shrink-0 d-flex align-items-center gap-1 mt-1">
                                                <i class="ri-time-line"></i> {{ notif.timeAgo }}
                                            </span>
                                        </div>
                                        <div class="font-size-13 text-muted lh-sm line-clamp-2 notif-message">
                                            {{ notif.mensagem }}
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div class="dropdown-footer-custom z-2 sticky-bottom">
                                <button class="btn btn-footer w-100 py-2 d-flex align-items-center justify-content-center gap-2 fw-semibold font-size-13 transition-all" @click="notificationStore.markAllAsRead()">
                                    Marcar todas como lidas <i class="ri-check-double-line transition-transform"></i>
                                </button>
                            </div>
                        </div>
                    </template>
                </DropdownField>
                
                <i :class="(uiStore.theme == 'light') ? 'ri-moon-line' : 'ri-sun-line'" class="font-size-22 text-secondary cursor-pointer" @click="uiStore.changeTheme()"></i>
            </div>

            <div class="flex-grow-1 text-center px-2">
                <span class="font-size-16 fw-bold header-title-mobile text-secondary">{{ currentAreaName }}</span>
            </div>

            <div class="d-flex align-items-center gap-3">
                <i class="ri-contacts-line font-size-22 text-secondary cursor-pointer" @click="uiStore.openContactsModal()"></i>
                <!-- Gerenciar Inbox some no aparelho de toque: configuração é só desktop. -->
                <i v-if="!isMobileDevice" class="ri-settings-3-line font-size-22 text-secondary cursor-pointer" @click="uiStore.openInboxModal()"></i>
            </div>
            
        </div>
        <ListHeader v-model="searchQuery" />
        
        <Transition name="context-switch" mode="out-in">
            
            <div :key="chatStore.chatContext" class="d-flex flex-column flex-grow-1 overflow-hidden position-relative">
                
                <!-- Treco de abinhas abaixo dos filtros e pesquisa -->
                <div class="flex-shrink-0">
                    <ListTabs v-if="!chatStore.isTeamMode && !internalChatStore.isInternalChatMode && uiStore.activeTab != 'AtendimentosIa'"
                        v-model:activeTab="activeTab" :searchQuery="searchQuery" />

                    <div v-else-if="uiStore.activeTab == 'AtendimentosIa'" class="px-4">
                        <ul class="nav nav-tabs nav-tabs-v2" role="tablist">

                            <li class="nav-item" role="presentation">
                                <a href="#" class="nav-link" :class="{ active: true }">
                                    Atendimentos por IA
                                    <span v-if="AIChatList.length > 0" class="tab-badge">
                                        {{ AIChatList.length }}
                                    </span>
                                </a>
                            </li>

                        </ul>
                    </div>
                    <div v-else class="px-4">
                        <ul class="nav nav-tabs nav-tabs-v2" role="tablist">

                            <!-- ABA CHATS -->
                            <li class="nav-item" role="presentation">
                                <a href="#" class="nav-link" :class="{ active: activeTeamSection === 'chats' }"
                                    @click.prevent="switchToChats">
                                    Chats
                                    <span v-if="filteredChatsCount > 0" class="tab-badge">
                                        {{ filteredChatsCount }}
                                    </span>
                                </a>
                            </li>

                            <!-- ABA CONTATOS -->
                            <li class="nav-item" role="presentation">
                                <a href="#" class="nav-link" :class="{ active: activeTeamSection === 'contacts' }"
                                    @click.prevent="switchToContacts">
                                    Contatos
                                    <span v-if="filteredContactsCount > 0" class="tab-badge">
                                        {{ filteredContactsCount }}
                                    </span>
                                </a>
                            </li>

                        </ul>
                    </div>
                </div>

                <Transition name="fade-slide">
                    <div v-if="!internalChatStore.isInternalChatMode && showHighVolumeWarning" class="px-3 mt-2">
                        <Transition name="fade-slide" mode="out-in">
                            
                            <div v-if="isWarningCollapsed" class="d-flex justify-content-center align-items-center py-1">
                                <button 
                                    class="btn btn-sm btn-badge-warning rounded-pill shadow-sm border d-flex align-items-center gap-2 px-3" 
                                    @click="isWarningCollapsed = false"
                                    title="Expandir aviso de desempenho"
                                >
                                    <span class="warning-pulse-dot"></span>
                                    <span class="font-size-11 fw-bold letter-spacing-custom">OTIMIZAR SISTEMA</span>
                                    <i class="ri-arrow-down-s-line font-size-14 ms-1"></i>
                                </button>
                            </div>

                            <div v-else class="compact-warning-card rounded-3 p-2 shadow-sm d-flex flex-column gap-2">
                                
                                <div class="d-flex align-items-start justify-content-between gap-2">
                                    <div class="d-flex align-items-center gap-2">
                                        <div class="warning-icon-bg flex-shrink-0 rounded-circle d-flex align-items-center justify-content-center mt-1">
                                            <i class="ri-speed-up-fill text-warning font-size-14"></i>
                                        </div>
                                        <div class="d-flex flex-column pe-1">
                                            <span class="font-size-12 fw-bold text-dark lh-sm">Otimize o sistema</span>
                                            <span class="font-size-11 text-muted lh-sm mt-1 text-wrap">Acima de 500 atendimentos abertos, o painel pode apresentar lentidão.</span>
                                        </div>
                                    </div>
                                    <button class="btn btn-sm btn-link text-muted p-0 text-decoration-none flex-shrink-0 hover-danger" @click="isWarningCollapsed = true" title="Recolher aviso">
                                        <i class="ri-close-line font-size-18"></i>
                                    </button>
                                </div>
                                
                                <button v-if="!isMobileViewport" class="btn btn-warning w-100 fw-bold text-dark font-size-11 py-1 rounded-pill shadow-sm border-0 d-flex align-items-center justify-content-center gap-1 hover-lift" @click="openBatchFinalize">
                                    <i class="ri-flashlight-fill"></i> Finalizar em Lote
                                </button>

                            </div>

                        </Transition>
                    </div>
                </Transition>

                <div 
                    class="chat-list-container custom-scrollbar"
                    ref="chatListRef"
                    @scroll="handleScroll"
                >
                    <!-- ⏳ Handler de loading state -->
                    <div
                        v-if="
                            internalChatStore.isInternalChatMode
                                ? (
                                    activeTeamSection === 'chats'
                                        ? internalChatStore.isLoadingChats
                                        : internalChatStore.isLoadingContacts
                                )
                                : chatStore.isLoadingChats
                        "

                        class="h-100 d-flex flex-column align-items-center justify-content-center text-muted"
                    >
                        <div class="spinner-border text-primary avatar-sm" role="status">
                            <span class="visually-hidden">Carregando...</span>
                        </div>
                    </div>
                    
                    <!-- Loading completo -->
                    <div v-else class="flex-grow-1 overflow-hidden d-flex flex-column">
                        <!-- 📋 Modo Lista -->
                        <div v-if="!internalChatStore.isInternalChatMode"
                            class="flex-grow-1 overflow-hidden d-flex flex-column">
                            <!-- 🤖 Atendimentos com IA -->
                            <template v-if="uiStore.activeTab == 'AtendimentosIa'">
                                <div class="list-unstyled chat-list chat-user-list px-2 mt-3 custom-scrollbar">
                                    <template v-for="chat, i in AIChatList" :key="`${i}-${chat.id}`">
                                        <ChatItem
                                            :chat="(chat as Chat)"
                                            :showTime="true"
                                            @select="onSelectChat"
                                            :force-pulsate-state="false"
                                        />
                                    </template>
                                    <div v-if="!AIChatList?.length" class="empty_state text-center mt-5" >
                                        <p class="text-muted">Nenhuma conversa encontrada.</p>
                                    </div>
                                </div>
                            </template>
                            <!-- 🙎 Atendimentos normais -->
                            <template v-else>
                                <div v-if="activeTab === 'tudo' && !chatStore.isTeamMode" id="combined-vlist-container">
                                    <UseVirtualList 
                                        v-if="combinedListComContatos?.length" 
                                        ref="virtualListRef"
                                        :list="combinedListComContatos" 
                                        :options="opcoesListaComContatos" 
                                        :style="{ height: listHeight }" 
                                        class="list-unstyled chat-list chat-user-list px-2 mt-3 custom-scrollbar"
                                        @scroll.passive="handleVirtualScroll"
                                    >
                                        <template #default="{data: chat}">
                                            <ChatItem
                                                v-if="chat.itemType === 'chat'"
                                                :key="chat.id"
                                                :chat="chat"
                                                :showTime="true"
                                                @select="onSelectChat"
                                            />
                                            <GroupItem
                                                v-else-if="chat.itemType === 'group'"
                                                :key="chat.id"
                                                :group="chat"
                                            />
                                            <ContactSearchHeader
                                                v-else-if="chat.itemType === 'contatos-header'"
                                                :key="chat.id"
                                                :sem-atendimentos="chat.semAtendimentos"
                                                :entrada="chat.entrada"
                                                :saindo="chat.saindo"
                                            />
                                            <ContactSearchLoading
                                                v-else-if="chat.itemType === 'contatos-carregando'"
                                                :key="chat.id"
                                                :saindo="chat.saindo"
                                            />
                                            <ContactSearchItem
                                                v-else-if="chat.itemType === 'contato'"
                                                :key="chat.id"
                                                :linha="chat"
                                                :termo="searchQuery"
                                                @select="buscaContatos.abrirAtendimentoPara"
                                            />
                                        </template>
                                    </UseVirtualList>
    
                                    <div
                                        v-if="!chatStore.isTeamMode && !combinedListComContatos?.length"
                                        class="empty_state text-center mt-5"
                                    >
                                        <p class="text-muted">Nenhuma conversa encontrada.</p>
                                    </div>
                                </div>
                            </template>

                            <ChatList
                                v-if="activeTab === 'atendimentos' && !chatStore.isTeamMode && uiStore.activeTab != 'AtendimentosIa'"
                                @select-chat="onSelectChat"
                                @scroll="handleVirtualScroll"
                                :reset-scroll="resetScroll"
                                :chats="(filteredChats as Chat[])"
                                :contatos="buscaContatos.linhasAposAtendimentos(filteredChats.length)"
                                :termo="searchQuery"
                                @select-contato="buscaContatos.abrirAtendimentoPara"
                            />
                        </div>

                        <!-- 🔹 MODO TIME: EXIBE CHATS E CONTATOS INTERNOS -->
                        <div v-else class="flex-grow-1 overflow-hidden d-flex flex-column">

                            <div class="flex-grow-1 overflow-auto">
                            <!-- 🔹 TEAM: CHATS -->
                            <ul v-if="activeTeamSection === 'chats'"
                                class="list-unstyled chat-list chat-user-list px-2 mt-3">
                                <ChatItem v-for="chat in filteredChats" :key="chat.id" :chat="(chat as Chat)"
                                    @select="onSelectChat" />
                            </ul>

                            <!-- 🔹 TEAM: CONTATOS -->
                            <ul v-else-if="activeTeamSection === 'contacts'"
                                class="list-unstyled chat-list chat-user-list px-2 mt-3">
                                <ChatItem v-for="contact in filteredChats" :key="contact.id" :chat="(contact as Chat)"
                                    :showTime="false" @select="onSelectContact((contact as Chat))" />
                            </ul>

                            </div>
                        </div>
                        
                        <GroupList
                            v-if="activeTab === 'grupos' && uiStore.activeTab != 'AtendimentosIa'"
                            :groups="(filteredGroups as Chat[])" 
                            @scroll="handleVirtualScroll"
                            :reset-scroll="resetScroll"
                        />

                        <div v-if="activeTab === 'favoritos' && uiStore.activeTab != 'AtendimentosIa'">
                            <ul class="list-unstyled chat-list chat-user-list px-2 mt-3 pb-3">
                                <template v-for="item in favoriteList" :key="item.id">
                                    <ChatItem
                                        v-if="item.itemType === 'chat'"
                                        :chat="(item as Chat)"
                                        @select="onSelectChat"
                                    />
                                    <GroupItem
                                        v-else-if="item.itemType === 'group'"
                                        :group="(item as Chat)"
                                    />
                                </template>
                            </ul>
                            <div v-if="!favoriteList?.length" class="empty_state text-center mt-5">
                                <i class="ri-star-line font-size-24 text-muted mb-2 d-block"></i>
                                <p class="text-muted">Nenhuma conversa favorita.</p>
                            </div>
                        </div>
                        
                        <!-- EMPTY STATE - APENAS CHAT INTERNO -->
                        <div
                            v-if="showInternalEmptyState"
                            class="empty_state text-center mt-5"
                        >
                            <i class="ri-chat-3-line font-size-24 text-muted mb-2 d-block"></i>

                            <p class="text-muted">
                                {{ internalEmptyMessage }}
                            </p>
                        </div>

                    </div>
                </div>

                <Transition name="fade">
                    <button 
                        v-show="showScrollTop" 
                        class="btn-scroll-top shadow-lg"
                        @click="scrollToTop"
                        title="Voltar ao topo"
                    >
                        <i class="ri-arrow-up-line"></i>
                    </button>
                </Transition>

            </div>
        </Transition>

        <div class="mx-auto w-100 mb-2 bottom-0 px-2">
            <ButtonWebsocketReconnect :should-show-reconnect-btn="chatStore?.initialized ? !chatStore.isWsConnected : false"/>
        </div>
    </div>
</template>

<script setup lang="ts">
import { useChatStore } from '@/stores/app/chatStore';
import { ChatUI, useInternalChatStore } from '../../../../stores/app/chatInternoStore';
import ListHeader from './ListHeader.vue';
import ListTabs from './ListTabs.vue';
import ChatList from './ChatList.vue';
import GroupList from './GroupList.vue';
import ChatItem from './ChatItem.vue';
import GroupItem from './GroupItem.vue';
import ContactSearchHeader from './ContactSearchHeader.vue';
import ContactSearchItem from './ContactSearchItem.vue';
import ContactSearchLoading from './ContactSearchLoading.vue';
import { computed, ComputedRef, ref, watch } from 'vue';
import ButtonWebsocketReconnect from './ButtonWebsocketReconnect.vue';
import { vListCalcHeight } from '@/utils/v-list-calc-height.composable';
import { Chat } from '@/mocks/app/mockChatData';
import { useAuthStoreUser } from '@/stores/app/authUser';
import { UseVirtualList } from '@vueuse/components';
import { throttle } from '@/utils/throttle';
import { useUiStore } from '@/stores/app/uiStore';
import { DiscriminatedChat, MakeChat } from '@/stores/app/chatUtils';
import { useNotificationStore } from '@/stores/app/notificationStore';
import { useDevice } from '@/composables/useDevice';
import { ehAtendimentoOcultoPorCampanha } from '@/utils/campanhaAtendimento';
import { alturaLinhaLista, useBuscaContatosLista } from '@/composables/useBuscaContatosLista';

// Ações em Lote são exclusivas do desktop (inclui PWA instalado em desktop).
// isMobileDevice: Gerenciar Inbox também é só desktop, mas o corte é por
// capacidade do aparelho (toque, sem hover) — pega PWA e navegador do celular,
// sem punir o desktop com a janela estreita.
const { isMobileViewport, isMobileDevice } = useDevice();

const notificationStore = useNotificationStore();

const chatStore = useChatStore();
const authStore = useAuthStoreUser();
const internalChatStore = useInternalChatStore();

const searchQuery       = ref('');
// Predicado e normalização vivem em `MakeChat` para a lista e a contagem das abas
// usarem os MESMOS: quando divergiam, a badge mostrava um número e as linhas visíveis
// eram outras.
const normalize = MakeChat.normalizarBusca;
const activeTab         = ref('tudo');
const activeTeamSection = ref('chats');
const showScrollTop     = ref(false);

const chatListRef = ref<null|HTMLDivElement>(null);
const virtualListRef = ref<any>(null);
const resetScroll = ref(0);
const uiStore = useUiStore();

const currentAreaName = computed(() => {
    if (internalChatStore.isInternalChatMode || uiStore.activeTab === 'ChatEquipe') return 'Equipe';
    if (uiStore.activeTab === 'AtendimentosIa') return 'Assistente IA';
    if (uiStore.activeTab === 'Lista' || uiStore.activeTab === 'Home') return 'Lista';
    if (uiStore.activeTab === 'Kanban') return 'Kanban';
    if (uiStore.activeTab === 'Dashboard') return 'Dashboard';
    return 'Atendimentos';
});

const onlineContactsCount = computed(() => {
    if (!internalChatStore.isInternalChatMode) return 0;
    return internalChatStore.contacts.filter(c => c.isOnline).length;
});

// Contagem filtrada de chats internos
const filteredChatsCount = computed(() => {
    if (!internalChatStore.isInternalChatMode) return 0;
    const sq = normalize(searchQuery.value);
    if (!sq) return internalChatStore.chats.length;
    return internalChatStore.chats.filter(chat => normalize(chat.name).includes(sq)).length;
});

// Contagem filtrada de contatos internos
const filteredContactsCount = computed(() => {
    if (!internalChatStore.isInternalChatMode) return 0;
    const sq = normalize(searchQuery.value);
    if (!sq) return internalChatStore.contacts.length;
    return internalChatStore.contacts.filter(contact => normalize(contact.name).includes(sq)).length;
});

const showInternalEmptyState = computed(() => {
    // Nunca mostrar fora do chat interno
    if (!internalChatStore.isInternalChatMode) return false;

    // Enquanto carrega, não mostrar
    if (activeTeamSection.value === 'chats') {
        return (
            !internalChatStore.isLoadingChats &&
            internalChatStore.chats.length === 0
        );
    }

    if (activeTeamSection.value === 'contacts') {
        return (
            !internalChatStore.isLoadingContacts &&
            internalChatStore.contacts.length === 0
        );
    }

    return false;
});

const internalEmptyMessage = computed(() => {
    if (activeTeamSection.value === 'chats') {
        return 'Nenhum chat interno encontrado.';
    }

    if (activeTeamSection.value === 'contacts') {
        return 'Nenhum contato interno disponível.';
    }

    return '';
});
// Separa quem é Chat (Contatos) da lista global da Store
const chatsFromStore = computed(() => {
    return chatStore.chatList.filter(c => !c.isGroup && !c.id.startsWith('g') && !ehAtendimentoOcultoPorCampanha(c));
});
// Separa quem é Grupo da lista global da Store
const groupsFromStore = computed(() => {
    return chatStore.chatList.filter(c => c.isGroup === true || c.id.startsWith('g'));
});

const filteredList = computed(() => {
    const sq = normalize(searchQuery.value);

    const filters          = chatStore.listFilters;
    const selectedInboxIds = chatStore.selectedInboxIds;
    const selectedAgentIds = chatStore.selectedAgentIds;
    const selectedTagIds   = chatStore.selectedTagIds;

    // 🧑‍🤝‍🧑 CHAT INTERNO
    if (internalChatStore.isInternalChatMode) {
        const source = activeTeamSection.value === 'chats'
            ? internalChatStore.chats
            : internalChatStore.contacts;

        return source
            .filter(chat => !sq || normalize(chat.name).includes(sq))
            .map(chat => ({ ...chat, itemType: 'chat', idChatBotIa: null }));
    }

    const allItems: DiscriminatedChat[] = chatStore.filteredChatsWItemType;

    return allItems.filter(item => {
        // 1. Busca por texto — nome, código do contato e nome da COMUNIDADE do grupo.
        if (!MakeChat.chatCorrespondeABusca(item, sq)) return false;

        // 2. Filtros de Status/Atribuição (Lógica OR interna)
        if (!filters.todos) {
            let match = false;
            if (filters.naoLidos && item.unreadCount > 0) match = true;
            if (filters.meus && (item.itemType == 'group' || item.atendentes?.some(a => a.id === authStore.user?.id))) match = true;
            if (filters.admin && item.atendentes?.some(a => a.initials === 'ADM')) match = true;
            

            // Se nenhum dos fixos bateu, verificamos a lista de agentes selecionados
            if (!match && selectedAgentIds?.length > 0) {
                if (item.itemType == 'group') match = true;
                else match = item.atendentes?.some(a => selectedAgentIds.includes(a.id));
            }

            if (!match) return false;
        }

        // 3. Filtro de Instâncias (Independente)
        if (selectedInboxIds?.length > 0) {
            if (!selectedInboxIds.includes(item.idInbox)) return false;
        }

        // 4. Filtro de Etiquetas (Independente)
        if (selectedTagIds?.length > 0) {
            const itemTagIds = item.tags?.map(t => String(t.id)) || [];
            const hasTag = selectedTagIds.some(id => itemTagIds.includes(String(id)));
            if (!hasTag) return false;
        }

        return true;
    });
});

/**
 * Ordena a lista: fixados primeiro, depois por data decrescente.
 *
 * `time` vem nulo/vazio em grupo que ainda não recebeu mensagem (`ultimaMensagemData`
 * do servidor), e esse item vai para o fim da lista. O empate precisa devolver 0: um
 * comparador que nunca devolve 0 é inconsistente e o resultado passa a depender do
 * algoritmo de ordenação do motor — no Chrome (TimSort) os grupos sem mensagem subiam
 * para o topo, no Firefox ficavam no fim.
 */
function ordenarPorFixadoEData(a: DiscriminatedChat, b: DiscriminatedChat) {
    // 1. Prioridade para chats fixados
    if (a.isPinned && !b.isPinned) return -1;
    if (!a.isPinned && b.isPinned) return 1;

    // 2. Ordenação por data (ISO), sem data por último
    const dataA = a.time || '';
    const dataB = b.time || '';
    if (!dataA || !dataB) return dataA === dataB ? 0 : (dataA ? -1 : 1);

    return dataA === dataB ? 0 : (dataA > dataB ? -1 : 1);
}

const AIChatList = computed(() => filteredList
    .value
    .filter(chat => chat.itemType === 'chat' && (!!chat.idChatBotIa && !chat.statusIntegracaoIa))
    .toSorted(ordenarPorFixadoEData)
);
const combinedList = computed(() => filteredList
    .value
    .toSorted(ordenarPorFixadoEData)
    .filter(item => (!item.idChatBotIa || !!item.statusIntegracaoIa))
);
const filteredChats = computed(() => combinedList.value.filter(item => item.itemType === 'chat' && (!item.idChatBotIa || !!item.statusIntegracaoIa)));
const filteredGroups = computed(() => combinedList.value.filter(item => item.itemType === 'group' && (!item.idChatBotIa || !!item.statusIntegracaoIa)));
const favoriteList = computed(() => combinedList.value.filter(item => item.isFavorite && (!item.idChatBotIa || !!item.statusIntegracaoIa)));

/**
 * Busca de contatos no fim da lista: quem não está (ou não está só) num atendimento
 * aberto também aparece, e o clique abre o modal de abertura de atendimento.
 *
 * Só nas listas de atendimento do cliente — chat interno, modo equipe e a aba de IA
 * têm outra semântica de busca, e ali o termo nem chega ao composable.
 */
const termoBuscaContatos = computed(() =>
    internalChatStore.isInternalChatMode || chatStore.isTeamMode || uiStore.activeTab == 'AtendimentosIa'
        ? ''
        : searchQuery.value
);
const buscaContatos = useBuscaContatosLista(termoBuscaContatos);

const combinedListComContatos = computed(() => [
    ...combinedList.value,
    ...buscaContatos.linhasAposAtendimentos(combinedList.value.length),
]);
// Objeto estável: o `UseVirtualList` lê as opções uma vez, então a função tem de
// consultar a lista atual pelo `.value`, não capturar uma cópia.
const opcoesListaComContatos = { itemHeight: (i: number) => alturaLinhaLista(combinedListComContatos.value[i] as { itemType?: string }) };

// metodos
const { listHeight } = vListCalcHeight('combined-vlist-container', chatStore, { vList: virtualListRef, list: () => combinedListComContatos.value, triggersToRecalc: [activeTab, () => chatStore.isTeamMode, () => uiStore.activeTab] });

/**
 * Ao mudar para aba de Chats
 */
async function switchToChats() {
    activeTeamSection.value = 'chats';
}

/**
 * Ao mudar para aba de Contatos
 */
async function switchToContacts() {
    activeTeamSection.value = 'contacts';
    
    // Carrega contatos se não foi carregado ainda
    if (!internalChatStore.contacts.length) {
        await internalChatStore.fetchContacts();
    }
}

// Handler para o scroll da lista normal
function handleScroll() {
    const el = chatListRef.value;
    if (el) {
        showScrollTop.value = el.scrollTop > 300;
    }
}

// Handler específico para o scroll da Virtual List
function handleVirtualScroll(event: Event) {
    const target = event.target as HTMLElement;
    if (target) {
        showScrollTop.value = target.scrollTop > 300;
        carregarMaisContatosSePertoDoFim(target);
    }
}

/** Scroll infinito dos contatos, nas abas que os exibem no fim da lista. */
function carregarMaisContatosSePertoDoFim(target: HTMLElement) {
    if (!buscaContatos.ativo.value || buscaContatos.esgotado.value) return;
    if (activeTab.value !== 'tudo' && activeTab.value !== 'atendimentos') return;

    const threshold = 300;
    if (target.scrollHeight - threshold - target.clientHeight - target.scrollTop <= 0) {
        void buscaContatos.carregarMais();
    }
}

function scrollToTop() {
    // Se estiver na aba 'tudo' (Virtual List)
    if (activeTab.value === 'tudo' && !chatStore.isTeamMode && virtualListRef.value) {
        if (virtualListRef.value.scrollTo) {
            virtualListRef.value.scrollTo(0);
        } else if (virtualListRef.value.$el) {
            virtualListRef.value.$el.scrollTo({ top: 0, behavior: 'smooth' });
        }
    } 
    // Caso contrário (Lista Normal)
    else {
        resetScroll.value++;
        const el = chatListRef.value;
        if (el) {
            el.scrollTo({ top: 0, behavior: 'smooth' });
        }
    }
}

function onSelectContact(contact: Chat) {
    internalChatStore.createChatWithContact(contact.id);
}

function onSelectChat(chat: Chat|ChatUI) {
    if (internalChatStore.isInternalChatMode) {
        internalChatStore.setActiveChat(chat as ChatUI);
    } else {
        chatStore.selectChat((chat as Chat).id);
    }
}

watch(activeTeamSection, async (section) => {
    if (
        section === 'contacts' &&
        internalChatStore.isInternalChatMode &&
        !internalChatStore.contacts.length
    ) {
        await internalChatStore.fetchContacts();
    }
})


// Trocar de aba desmonta a lista (v-if por aba), que volta no topo: o botão de voltar
// ao topo tem que sumir junto. Mudança no tamanho da lista NÃO remonta mais nada e
// mantém o scroll, então o botão continua valendo.
watch(activeTab, () => { showScrollTop.value = false; });

watch(() => internalChatStore.isInternalChatMode, async (isInternal) => {
    if (!isInternal) return;

    await internalChatStore.fetchChats();

    // 🔥 carrega contatos em background só para contagem
    if (!internalChatStore.contacts.length) {
        internalChatStore.fetchContacts();
    }

    activeTeamSection.value = 'chats';
}, {immediate: true})

const totalAtendimentos = computed(() => {
    // Conta apenas os chats (ignorando grupos) globais do store. Atendimento criado
    // por campanha e ainda sem resposta não conta: ele não está na lista, e contá-lo
    // dispararia o aviso de alto volume por uma fila que ninguém vê.
    return chatStore.chatList.filter(c => !c.isGroup && !c.id.startsWith('g') && !ehAtendimentoOcultoPorCampanha(c)).length;
});

const showHighVolumeWarning = computed(() => totalAtendimentos.value >= 450);
const isWarningCollapsed = ref(false);
function openBatchFinalize() {
    uiStore.openBatchActionModal();
    // Dispara um evento global customizado para que o Modal saiba que deve pré-selecionar 'FINALIZAR'
    setTimeout(() => {
        window.dispatchEvent(new CustomEvent('set-batch-action', { detail: 'FINALIZAR' }));
    }, 100);
}
</script>

<style scoped>
.nav-item {
    font-size: 0.789rem !important;
}

.nav-tabs-v2 {
    border-bottom: none;
}

.nav-tabs-v2 .nav-link {
    border: none;
    border-bottom: 3px solid transparent;
    color: var(--bs-text-muted);
    padding: 10px 4px;
    margin-right: 16px;
    font-weight: 600;
    text-decoration: none;
    display: flex;
    align-items: center;
    gap: 6px;
}

.nav-tabs-v2 .nav-link i {
    font-size: 14px;
    vertical-align: middle;
    margin-top: -2px;
    margin-right: 2px;
}

.nav-tabs-v2 .nav-link.active,
.nav-tabs-v2 .nav-link:hover {
    color: var(--bs-success);
    border-bottom-color: var(--bs-success);
    background-color: transparent;
}

.tab-badge {
    background-color: #f0f2f5;
    color: #6c757d;
    font-size: 10px;
    padding: 2px 6px;
    border-radius: 12px;
    font-weight: 700;
    transition: all 0.2s;
}

[data-bs-theme="dark"] .tab-badge {
    background-color: #f0f2f514;
    color: #70777d;
}

.nav-tabs-v2 .nav-link.active .tab-badge {
    background-color: rgba(var(--bs-success-rgb), 0.15); /* Fundo verde bem claro */
    color: var(--bs-success); /* Texto verde */
}

.chat-leftsidebar {
    display: flex;
    flex-direction: column;
    height: 100vh;
    background-color: var(--bs-sidebar-sub-bg);
    overflow: hidden;
}

.chat-list-container {
    flex-grow: 1;
    overflow-y: auto;
    height: 0;
}

.spin { display: inline-block; animation: spin 1s linear infinite; }
@keyframes spin { from { transform: rotate(0deg); } to { transform: rotate(360deg); } }

.custom-scrollbar {
    overflow-y: auto;
    margin-right: 2px;
}
.custom-scrollbar::-webkit-scrollbar { width: 6px; }
.custom-scrollbar::-webkit-scrollbar-thumb { background: #e7eaee; border-radius: 4px; }
[data-bs-theme="dark"] .custom-scrollbar::-webkit-scrollbar-thumb { background: #3b4045; }

.context-switch-enter-active,
.context-switch-leave-active {
    transition: all 0.25s cubic-bezier(0.25, 0.8, 0.25, 1);
}
.context-switch-enter-from {
    opacity: 0;
    transform: translateY(15px);
}
.context-switch-leave-to {
    opacity: 0;
    transform: translateY(-15px);
}

.nav-item{
    font-size: 0.789rem !important;
}
.nav-tabs-v2 {
    border-bottom: none; /* Ajustado de 'none' */
}
.nav-tabs-v2 .nav-link {
    border: none;
    border-bottom: 3px solid transparent;
    color: var(--bs-text-muted);
    padding: 10px 4px;
    margin-right: 16px;
    font-weight: 600;
    text-decoration: none; 
}

/* NOVO: Estilo para o ícone na aba */
.nav-tabs-v2 .nav-link i {
    font-size: 14px;
    vertical-align: middle;
    margin-top: -2px;
    margin-right: 2px;
}

.nav-tabs-v2 .nav-link.active,
.nav-tabs-v2 .nav-link:hover {
    color: var(--bs-success);
    border-bottom-color: var(--bs-success);
    background-color: transparent;
}

.btn-scroll-top {
    position: absolute;
    bottom: 20px;
    right: 25px; /* Afastado levemente para não cobrir a barra de rolagem */
    width: 40px;
    height: 40px;
    border-radius: 50%;
    background-color: var(--bs-success);
    color: white;
    border: none;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    z-index: 100;
    transition: all 0.3s ease;
}

.btn-scroll-top:hover {
    background-color: #05b588;
    transform: translateY(-3px);
}

.btn-scroll-top i {
    font-size: 20px;
}

/* Animação de entrada/saída */
.fade-enter-active,
.fade-leave-active {
    transition: opacity 0.3s ease;
}

.fade-enter-from,
.fade-leave-to {
    opacity: 0;
}

/* =========================================
   AVISO DE DESEMPENHO (SMART BANNER)
   ========================================= */

.compact-warning-card {
    background-color: var(--bs-white);
    border: 1px solid rgba(234, 179, 8, 0.3);
    transition: all 0.2s ease;
}

.warning-icon-bg {
    width: 26px;
    height: 26px;
    background-color: rgba(234, 179, 8, 0.15);
}

/* Pílula do estado recolhido */
.btn-badge-warning {
    background-color: var(--bs-white);
    border-color: rgba(234, 179, 8, 0.4);
    color: #ca8a04;
    transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1);
    outline: none;
}

.btn-badge-warning:hover {
    background-color: #fef08a;
    color: #a16207;
    border-color: #eab308;
    transform: translateY(-1px);
}

.letter-spacing-custom {
    letter-spacing: 0.3px;
}

/* Ponto pulsante */
.warning-pulse-dot {
    width: 6px;
    height: 6px;
    background-color: #eab308;
    border-radius: 50%;
    box-shadow: 0 0 0 0 rgba(234, 179, 8, 0.4);
    animation: warning-pulse 2s infinite;
}

@keyframes warning-pulse {
    0% { box-shadow: 0 0 0 0 rgba(234, 179, 8, 0.4); }
    70% { box-shadow: 0 0 0 4px rgba(234, 179, 8, 0); }
    100% { box-shadow: 0 0 0 0 rgba(234, 179, 8, 0); }
}

.hover-danger:hover i {
    color: var(--bs-danger);
}

/* Suporte Nativo ao Dark Mode */
[data-bs-theme="dark"] .compact-warning-card {
    background-color: #252525;
    border-color: rgba(234, 179, 8, 0.2);
}
[data-bs-theme="dark"] .btn-badge-warning {
    background-color: #2b2b2b;
    border-color: rgba(234, 179, 8, 0.3);
    color: #fde047;
}
[data-bs-theme="dark"] .btn-badge-warning:hover {
    background-color: #3f3514;
    border-color: #715c1b;
}

/* Transição muito suave (Impede saltos feios) */
.fade-slide-enter-active,
.fade-slide-leave-active {
    transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1);
}
.fade-slide-enter-from,
.fade-slide-leave-to {
    opacity: 0;
    transform: translateY(-5px);
}

.icon-home-mobile{
    background: var(--bs-light) !important;
    border-radius: 50%  !important;
    padding: 8px;
}

/* =========================================
   ESTILOS DO DROPDOWN DE NOTIFICAÇÕES
   ========================================= */
.notification-dropdown {
    width: 330px;
    background: var(--bs-white);
    border-radius: 1rem;
    box-shadow: 0 16px 48px rgba(0, 0, 0, 0.12);
    display: flex;
    flex-direction: column;
    position: relative !important;
    overflow: visible !important;
}

[data-bs-theme="dark"] .notification-dropdown {
    box-shadow: 0 16px 48px rgba(0, 0, 0, 0.5);
}

/* Seta apontando para cima (Ajustado para o ListUser) */
.notification-dropdown::before {
    content: "";
    position: absolute;
    top: -10px;
    left: 20px;
    width: 0;
    height: 0;
    border-left: 10px solid transparent;
    border-right: 10px solid transparent;
    border-bottom: 12px solid var(--bs-body-bg);
    display: block;
    z-index: 9999;
}
[data-bs-theme="dark"] .notification-dropdown::before { border-bottom-color: var(--bs-body-bg); }

.dropdown-header-custom { padding: 20px 20px 16px 20px; background: var(--bs-body-bg); border-top-left-radius: 1rem; border-top-right-radius: 1rem; }
.dropdown-header-custom h6 { color: var(--bs-heading-color); letter-spacing: -0.3px; }
.btn-mark-read { transition: opacity 0.2s; }
.btn-mark-read:hover { opacity: 0.8; text-decoration: underline !important; }
.notification-body { max-height: 420px; overflow-y: auto; padding: 0 12px 12px 12px; background: var(--bs-body-bg); }

.notification-item { background: var(--bs-tertiary-bg); border: 1px solid transparent; border-radius: 12px; padding: 16px; margin-bottom: 8px; transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1); }
.notification-item:last-child { margin-bottom: 0; }
.notification-item:hover { transform: translateY(2px); box-shadow: 0 8px 24px rgba(0, 0, 0, 0.06); border-color: var(--bs-primary-rgb); background: var(--bs-body-bg); }

[data-bs-theme="dark"] .notification-item { background: rgba(255, 255, 255, 0.03); }
[data-bs-theme="dark"] .notification-item:hover { background: var(--bs-secondary-bg); box-shadow: 0 8px 24px rgba(0,0,0,0.2); }

.notification-item.is-unread { background: var(--bs-primary-bg-subtle); }
[data-bs-theme="dark"] .notification-item.is-unread { background: rgba(var(--bs-primary-rgb), 0.08); }
.unread-indicator { position: absolute; top: 50%; left: 0; transform: translateY(-50%); width: 4px; height: 32px; background-color: var(--bs-primary); border-radius: 0 4px 4px 0; }

.notif-icon-wrapper { width: 42px; height: 42px; font-size: 20px; }
.notif-icon-wrapper.icon-system { background-color: rgba(var(--bs-info-rgb), 0.12); color: var(--bs-info); }
.notif-icon-wrapper.icon-warning { background-color: rgba(var(--bs-warning-rgb), 0.15); color: var(--bs-warning); }
.notif-icon-wrapper.icon-success { background-color: rgba(var(--bs-success-rgb), 0.12); color: var(--bs-success); }
.notif-title { color: var(--bs-heading-color); max-width: 190px; }
.line-clamp-2 { display: -webkit-box; -webkit-line-clamp: 2; line-clamp: 2; -webkit-box-orient: vertical; overflow: hidden; }

.dropdown-footer-custom { background: var(--bs-body-bg); padding: 12px 16px 16px 16px; border-top: 1px solid transparent; border-bottom-left-radius: 1rem; border-bottom-right-radius: 1rem; }
.btn-footer { color: var(--bs-heading-color); background: var(--bs-tertiary-bg); border-radius: 10px; border: 1px solid transparent; }
.btn-footer:hover { background: var(--bs-primary-rgb); color: var(--bs-primary); border-color: var(--bs-border-color-translucent); }
.btn-footer:hover i { transform: translateX(4px); }

.icon-ATENDIMENTO_TRANSFERIDO { background-color: #e8f4fd; color: #2196f3; }
.icon-ATENDIMENTO_FINALIZADO { background-color: #e8f8f0; color: #4caf50; }
.icon-SINCRONIZACAO_CONTATOS_CONCLUIDA { background-color: #f3e8fd; color: #9c27b0; }
.icon-IMPORTACAO_CONTATOS_CONCLUIDA { background-color: #fff8e1; color: #ff9800; }
.icon-EXPORTACAO_CONVERSAS_CONCLUIDA { background-color: #e0f2f1; color: #009688; }
.icon-EXPORTACAO_CONVERSAS_ERRO { background-color: #fdecea; color: #e53935; }
[data-bs-theme="dark"] .icon-empty-state { background-color: var(--bs-secondary-bg) !important; }

.header-title-mobile {
    color: var(--bs-heading-color);
    letter-spacing: 0.3px;
    text-transform: uppercase;
    font-size: 14px;
}
[data-bs-theme="dark"] .header-title-mobile {
    color: #f8f9fa;
}

@media (max-width: 991.98px) {
    .chat-leftsidebar {
        padding-bottom: 65px !important; 
    }

    .btn-scroll-top {
        bottom: 20px !important; /* Distância entre o botão e a navbar */
        z-index: 1040 !important; /* Fica acima da lista, mas abaixo de modais (1050+) */
    }
}

</style>